import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { FaUser, FaLock, FaEye, FaEyeSlash } from "react-icons/fa";
import authProvider from "../providers/authProvider";
import Alert from "@mui/material/Alert";

export default function LoginPage() {
  const navigate = useNavigate();
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [showPassword, setShowPassword] = useState(false);
  const [error, setError] = useState(null);

  const handleSubmit = async e => {
    e.preventDefault();
    authProvider
      .login({ username, password })
      .then(d => {
        navigate("/admin");
      })
      .catch(error => {
        setError(error.message);
      });
  };

  return (
    <div style={styles.container}>
      {/* Cerchio sfumato */}
      <div style={styles.circle}>
        <div
          style={{
            textAlign: "center",
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            gap: "20px",
          }}
        >
          <img
            src={require("../image/simpleman-white.png")}
            alt="Logo"
            style={styles.logo}
          />
          <p
            style={{
              margin: 0,
              fontStyle: "italic",
              color: "white",
            }}
          >
            Il software di manutenzione più semplice d'Italia
          </p>

          <p
            style={{
              margin: 0,
              color: "white",
              fontSize: 13,
            }}
          >
            Hai già un account <b>Sacelman?</b> Puoi usare le stesse credenziali
          </p>
        </div>
        {/* Form di Login */}
        <form onSubmit={handleSubmit} style={styles.form}>
          {/* Campo Username */}
          <div style={styles.inputContainer}>
            <FaUser style={styles.icon} />
            <input
              type="text"
              placeholder="Codice utente"
              value={username}
              onChange={e => setUsername(e.target.value)}
              style={styles.input}
            />
          </div>
          {/* Campo Password */}
          <div style={styles.inputContainer}>
            <FaLock style={styles.icon} />
            <input
              type={showPassword ? "text" : "password"}
              placeholder="Password"
              value={password}
              onChange={e => setPassword(e.target.value)}
              style={styles.input}
            />
            <button
              type="button"
              onClick={() => setShowPassword(!showPassword)}
              style={styles.eyeButton}
            >
              {showPassword ? <FaEyeSlash /> : <FaEye />}
            </button>
          </div>
          {/* Pulsante Login */}
          <button type="submit" style={styles.button}>
            ACCEDI
          </button>
        </form>

        {/* Link Recupero Password e Registrazione */}
        <div style={styles.footer}>
          <a href="/" style={styles.link}>
            Non hai ancora l'account? Richiedi demo
          </a>
        </div>

        <div style={{ ...styles.footer, marginTop: -20 }}>
          <a
            href="https://www.sacelman.it/recover"
            rel="noreferrer"
            target="_blank"
            style={styles.link}
          >
            Non ricordi le credenziali? Recuperale
          </a>
        </div>
      </div>

      {error && (
        <Alert style={{ position: "absolute", bottom: 180 }} severity="error">
          {error}
        </Alert>
      )}
    </div>
  );
}

// Stili inline
const styles = {
  container: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    height: "100vh",
    backgroundColor: "#3a5081",
    position: "relative",
  },
  circle: {
    width: "50vh",
    height: "50vh",
    borderRadius: "15px",
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "space-around",
    backgroundColor: "#2a4071",
  },
  logo: {
    width: "50%",
  },
  form: {
    display: "flex",
    flexDirection: "column",
    gap: "10px",
  },
  inputContainer: {
    position: "relative",
    height: "auto",
    display: "flex",
    flexDirection: "row",
    alignItems: "center",
    justifyContent: "space-between",
  },
  input: {
    borderRadius: "5px",
    border: "1px solid #ccc",
    backgroundColor: "transparent",
    color: "white",
    fontSize: "16px",
    outline: "none",
    height: "auto",
    padding: "10px 40px",
  },
  icon: {
    position: "absolute",
    left: "10px",
    color: "#ccc",
  },
  eyeButton: {
    position: "absolute",
    right: "10px",
    color: "#ccc",
    background: "none",
    border: "none",
    cursor: "pointer",
  },
  button: {
    background: "linear-gradient(to right,rgb(219, 124, 60),rgb(233, 109, 64))",
    color: "white",
    padding: "12px",
    borderRadius: "5px",
    fontSize: "14px",
    fontWeight: "bold",
    border: "none",
    cursor: "pointer",
    width: "100%",
  },
  footer: {
    marginTop: "10px",
    fontSize: "12px",
    color: "white",
  },
  link: {
    color: "white",
    textDecoration: "none",
    fontWeight: 600,
  },
};
